const Error = (code, message) => ({ code, message });

export const ERROR_CODE = {
    ROUTE_ERROR: 1,
    ANIMATION_ERROR: 2,
    PRESENTATION_NON_SLIDE_CHILD_ERROR: 3,
    SCREEN_INVALID_LISTENER_ERROR: 4,
    DEVICE_CLASS_ERROR: 5,
};

export const RouteError = (message) => new Error(ERROR_CODE.ROUTE_ERROR, message);
export const AnimationError = (message) => new Error(ERROR_CODE.ANIMATION_ERROR, message);
export const PresentationNonSlideChildError = (message) => new Error(ERROR_CODE.PRESENTATION_NON_SLIDE_CHILD_ERROR, message);
export const ScreenInvalidListenerError = (message) => new Error(ERROR_CODE.SCREEN_INVALID_LISTENER_ERROR, message);
export const DeviceClassError = (message) => new Error(ERROR_CODE.DEVICE_CLASS_ERROR, message);